import { render, staticRenderFns } from "./TermsContent.vue?vue&type=template&id=49fe9f38&scoped=true&lang=pug&"
import script from "./TermsContent.vue?vue&type=script&lang=js&"
export * from "./TermsContent.vue?vue&type=script&lang=js&"
import style0 from "./TermsContent.vue?vue&type=style&index=0&id=49fe9f38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fe9f38",
  null
  
)

export default component.exports